import Badge from '@components/atoms/Badge'

import { scopedTranslation } from '@utils/I18n'

import { ShiftPublishState } from '@frontend/graphql/types.generated'

import { ChangeBreakdownDisclosure } from './ChangeBreakdownDisclosure'

import type { ChangeBreakdownFields } from '../shifts/types'

const t = scopedTranslation('roster_board')

type ShiftStatusBadgeProps = {
  publishState: ShiftPublishState
  changeBreakdown?: ChangeBreakdownFields | null
  roleName?: string
}

export function ShiftStatusBadge({ publishState, changeBreakdown, roleName }: ShiftStatusBadgeProps) {
  switch (publishState) {
    case ShiftPublishState.Published:
      return (
        <Badge color="success" leadingIcon="check">
          {t('status_published')}
        </Badge>
      )
    case ShiftPublishState.UnpublishedChanges: {
      if (!changeBreakdown) {
        return (
          <Badge color="warning" leadingIcon="alert-circle">
            {t('status_unpublished_changes')}
          </Badge>
        )
      }

      return <ChangeBreakdownDisclosure breakdown={changeBreakdown} roleName={roleName} />
    }
    case ShiftPublishState.PendingRemoval:
      return (
        <Badge color="error" leadingIcon="trash-01">
          {t('status_pending_removal')}
        </Badge>
      )
    case ShiftPublishState.Draft:
      return (
        <Badge color="muted">
          <span aria-hidden className="tw:h-1.5 tw:w-1.5 tw:rounded-full tw:bg-gray-600" />
          {t('status_draft')}
        </Badge>
      )
    case ShiftPublishState.Archived:
      return null // hidden state, filtered server-side before it reaches the board
    default: {
      const _exhaustive: never = publishState
      return _exhaustive
    }
  }
}
